import React, { Component } from 'react';
import * as Actions from '../../../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import _ from 'lodash';
import { SHIPPING_SELECT } from '../../../constants';

export class SelectShipping extends Component {

    constructor(props) {
        super(props)

        this.state = {
            branches: null,
            values: {
                branch: "",
                phoneNumber: ""
            },
            inputBranch: "",
            errors: null,
            validateChangeShipping: {
                phoneNumber: {
                    presence: true,
                    numericality: { onlyInteger: true },
                    format: /\d{10}/
                },
                branch: {
                    presence: true,
                    inclusion: {}
                }
            },
            pickupDate: "",
            allowDeliveryToBranch: false
        }
    }

    async UNSAFE_componentWillMount() {
        const { GetBranch, wording, GetPickupDate, GetBranchSetting } = this.props;
        await GetBranchSetting().then(branchSetting => this.setState({ allowDeliveryToBranch: branchSetting.allowDeliveryToBranch }));

        await GetBranch().then(branches => {
            this.setState({
                branches,
                validateChangeShipping: {
                    ...this.state.validateChangeShipping,
                    branch: {
                        inclusion: {
                            within: branches,
                            message: wording.checkoutPage.selectShipping.errorBranch
                        }
                    }
                }
            });
        });
        await GetPickupDate().then(pickupDate => this.setState({ pickupDate }));
    }

    componentDidMount() {
        this.handleCheckError();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevState.values, this.state.values)) {
            this.handleCheckError();
        }
    }

    handleCheckError = async () => {
        const { values, validateChangeShipping } = this.state;
        const errors = validate(values, validateChangeShipping);

        const isValid = errors ? false : true;

        this.setState(prevSt => ({
            ...prevSt,
            errors: errors || null
        }));

        await this.props.onChangeDataShippingBranch({ value: isValid, name: "isValid" });

        if (!isValid) await this.props.onChangeDataShippingBranch({ value: Object.keys(errors), name: "errors" });

        if (!errors?.hasOwnProperty("phoneNumber")) this.props.onChangeDataShippingBranch({ value: values.phoneNumber, name: "phoneNumber" });
    }

    handleChangeSelectedBranch = e => {
        e.persist();
        const { branches, values } = this.state;
        let value = e.target.value;
        this.setState({ inputBranch: value });
        let branchSelected = branches?.find(branch => branch.name?.trim() == value);
        if (branchSelected) this.props.onChangeDataShippingBranch({ value: branchSelected.id, name: "branchId" });
        this.setState({ values: { ...values, branch: branchSelected || { name: value } } });
    }

    handleChangePhoneNumber = e => {
        e.persist();
        const { values } = this.state;
        this.setState({ values: { ...values, phoneNumber: e.target.value } });
    }

    render() {
        const { onChangeSelected, shippingSelected, wording } = this.props;
        const { branches, values, errors, inputBranch, pickupDate, allowDeliveryToBranch } = this.state;

        return (
            <>
                {
                    allowDeliveryToBranch &&
                    <div className="col-md-12 p-0">
                        <div className="mt-60">
                            <h2 className="heading relative heading-small uppercase bottom-line style-2 left-align mb-30">{wording.checkoutPage.selectShipping.title}</h2>
                        </div>
                        <div className="mb-0">
                            <div className="form-check mb-20">
                                <input className="form-check-input" type="radio" name="shipping" onChange={() => onChangeSelected(SHIPPING_SELECT.POST_OFFICE)} id="shippingPostOffice" checked={shippingSelected == SHIPPING_SELECT.POST_OFFICE} />
                                <label className="form-check-label" htmlFor="shippingPostOffice">
                                    {wording.checkoutPage.selectShipping.postOffice}
                                </label>
                            </div>
                            {
                                true &&
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="shipping" onChange={() => onChangeSelected(SHIPPING_SELECT.BRANCH)} id="shippingBranch" checked={shippingSelected == SHIPPING_SELECT.BRANCH} />
                                    <label className="form-check-label" htmlFor="shippingBranch">
                                        {wording.checkoutPage.selectShipping.branch}
                                        {
                                            // pickupDate && <span className="ml-10">{`สามารถรับสินค้าได้ตั้งแต่ ${pickupDate}`}</span>
                                        }
                                    </label>
                                </div>
                            }
                        </div>
                    </div>
                }

                {
                    shippingSelected == SHIPPING_SELECT.BRANCH &&
                    <div className="col-md-12 p-0">
                        <div className="mt-60">
                            <h2 className="heading relative heading-small uppercase bottom-line style-2 left-align mb-30">{wording.checkoutPage.selectShipping.shippingBranch.title}</h2>
                        </div>
                        <div className="mb-0">
                            <div className="branch-shipping-detail pt-5">
                                <div className="input-boder-bottom">
                                    <i className="fas fa-code-branch font-size-20 mr-10"></i>
                                    <input type="text" className="w-25 text-white" list="listBranches" id="input-select-branch" value={inputBranch} onChange={(e) => this.handleChangeSelectedBranch(e)} />
                                    <label htmlFor="input-select-branch" className="text-white">{wording.checkoutPage.selectShipping.shippingBranch.selectBranch}</label>
                                    <datalist id="listBranches">
                                        {
                                            branches?.map((branch, index) => (
                                                <option key={`branch-${index}`}>{branch.name}</option>
                                            ))
                                        }
                                    </datalist>
                                    {errors?.hasOwnProperty("branch") && <span className='error ml-10'>* {errors?.branch[0]}</span>}
                                </div>
                                <div className="input-boder-bottom">
                                    <i className="fas fa-phone-alt font-size-20 mr-10"></i>
                                    <input maxLength={10} type="text" className="w-25 text-white" id="input-telephone" value={values.phoneNumber} onChange={(e) => this.handleChangePhoneNumber(e)} />
                                    <label htmlFor="input-telephone" className="text-white">{wording.checkoutPage.selectShipping.shippingBranch.phoneNumber}</label>
                                    {errors?.hasOwnProperty("phoneNumber") && <span className='error ml-10'>* {errors?.phoneNumber[0]}</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </>
        )
    }
}

const mapStateToProps = ({ language }) => ({
    wording: language.wording
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        GetBranch: Actions.getBranch,
        GetPickupDate: Actions.GetPickupDate,
        GetBranchSetting: Actions.getBranchSetting
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectShipping);
